import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { capitalizeFirstLetter } from '../helpers.js';

import s from './TextFieldEditor.module.scss';

export default class TextFieldEditor extends Component {
    static propTypes = {
        big: PropTypes.bool,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        iconLeft: PropTypes.string,
        inputBoxClass: PropTypes.string,
        invalid: PropTypes.bool,
        label: PropTypes.string,
        link: PropTypes.bool,
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onClickLink: PropTypes.func,
        password: PropTypes.bool,
        placeHolder: PropTypes.string,
        value: PropTypes.string,
        firstLetterUppercase: PropTypes.bool,
    };

    static defaultProps = {
        big: false,
        className: '',
        disabled: false,
        iconLeft: '',
        inputBoxClass: '',
        invalid: false,
        label: '',
        link: false,
        name: '',
        onBlur: () => {},
        onChange: () => {},
        onClickLink: () => {},
        password: false,
        placeHolder: '',
        value: '',
        firstLetterUppercase: false,
    };

    constructor(props) {
        super(props);
        this.state = { inputFocused: false, value: props.value };
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.value !== newProps.value) this.setState({ value: newProps.value || '' });
    }

    renderRightIcon = () => {
        if (this.state.inputFocused && this.state.value) {
            return (
                <span
                    className={classNames(s.rightIcon, 'icon-close')}
                    onMouseDown={e => {
                        e.preventDefault();
                        this.setState({ value: '' });
                        this.props.onChange('');
                    }}
                />
            );
        }
        return null;
    };

    renderLink = () => {
        const { onClickLink } = this.props;
        return (
            <button type="button" className={s.link} onClick={onClickLink} data-cy='ForgetPasswordBtn'>
                Forget your password?
            </button>
        );
    };

    handleTextChange = event => {
        const { value } = event.target;
        this.setState({ value });
        this.props.onChange(value);
    };

    renderInputBox = () => {
        const { onBlur, iconLeft, name, placeHolder, password, disabled, invalid, inputBoxClass, label } = this.props;
        const { value } = this.state;
        const inputType = password ? 'password' : 'text';
        const inputClasses = classNames({ [s.hasLeftIcon]: iconLeft, [s.invalid]: invalid }, inputBoxClass);
        return (
            <div
                className={s.inputBox}
                onFocus={() => this.setState({ inputFocused: true })}
                onBlur={() => {
                    this.setState({ inputFocused: false });
                    if (onBlur) onBlur();
                }}
            >
                <span className={classNames(s.leftIcon, iconLeft)} />
                {this.renderRightIcon()}
                <input
                    {...{ name }}
                    ref={input => {
                        this.textInput = input;
                    }}
                    className={inputClasses}
                    value={value || ''}
                    placeholder={placeHolder}
                    onChange={this.handleTextChange}
                    disabled={disabled}
                    type={inputType}
                    data-cy={`${label}-inputField`}
                    data-testid={'search-input'}
                />
            </div>
        );
    };

    render() {
        const { className, label, disabled, big, link, firstLetterUppercase } = this.props;
        const classes = classNames(className, s.textFieldEditor, { [s.disabled]: disabled }, { [s.big]: big });

        return (
            <div className={classes}>
                <div className={s.label}>
                    {firstLetterUppercase ? capitalizeFirstLetter(label) : label.toUpperCase()} {link ? this.renderLink() : null}{' '}
                </div>
                {this.renderInputBox()}
            </div>
        );
    }
}
